import { useRef } from 'react';

import { BaseEmoji } from '../../emoji-picker';

export const useEmojiPopover = () => {
  const textRef = useRef<HTMLTextAreaElement>(null);

  const setEmoji = (emoji: BaseEmoji) => {
    if (!textRef.current) return;

    const [start, end] = [textRef.current.selectionStart, textRef.current.selectionEnd];
    const emojiNative: string = emoji.native;
    textRef.current.setRangeText(emojiNative, start, end);
    textRef.current.setSelectionRange(start + emojiNative.length, end + emojiNative.length);
    textRef.current.dispatchEvent(new Event('input', { bubbles: true })); // execute onChange event
    textRef.current.focus();
  };

  return {
    setEmoji,
    textRef,
  };
};
